//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from "vuex";

export default {
    name: "BowLocomotiveScrollCols",

    data: () => ({}),

    computed: {
        ...mapState({
            scroll: ({ scroll }) => scroll.scroll,
            limit: ({ scroll }) => scroll.limit,
            pageHeight: ({ scroll }) => scroll.pageHeight,
        }),

        ...mapGetters([
            "scroll/GET_SCROLL",
            "scroll/GET_LIMIT",
            "scroll/getPageHeight",
        ]),
    },

    mounted() {
        this.locomotive = this.$refs.scroller.locomotive;

        this.observeWrapper = new ResizeObserver(() => {
            this.$nuxt.$emit("update-locomotive");
        });

        this.observeWrapper.observe(
            document.querySelector(".b-scroll__wrapper")
        );
    },

    methods: {
        ...mapActions([
            "scroll/UPDATE_SCROLL",
            "scroll/UPDATE_LIMIT",
            "scroll/updatePageHeight",
        ]),
    },
};
